import React from 'react';
import { CATEGORIES, BLOG_URL } from '../data/categories';

function About() {
  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">About How To Bachelor</h1>
      </div>

      <div className="page-body">
        <p>
          Welcome to <strong>How To Bachelor</strong> - your comprehensive guide to thriving in bachelor life.
          Whether you're living on your own for the first time or looking to level up your independent lifestyle,
          we're here to help.
        </p>

        <h2>Our Mission</h2>
        <p>
          We believe that bachelor living shouldn't mean sacrificing your health, happiness, or home-cooked meals.
          Our mission is to provide practical, no-nonsense advice that helps men live their best lives independently.
        </p>

        <h2>What We Cover</h2>
        <p>
          Our writing lives over on <a href={BLOG_URL} target="_blank" rel="noopener noreferrer">the blog</a>,
          organized into five areas:
        </p>

        {CATEGORIES.map((category) => (
          <React.Fragment key={category.slug}>
            <h3>
              {category.icon}{' '}
              <a href={category.url} target="_blank" rel="noopener noreferrer">{category.name}</a>
            </h3>
            <p>{category.description}</p>
          </React.Fragment>
        ))}

        <h2>Our Philosophy</h2>
        <p>
          Think of us as your favorite barbershop - a welcoming space where you can get straight talk,
          practical advice, and genuine support. We keep things relaxed, real, and focused on what actually works.
        </p>

        <p>
          We're not here to judge or lecture. We're here to share knowledge, build community, and help you
          create a bachelor lifestyle you're proud of.
        </p>

        <h2>Get In Touch</h2>
        <p>
          Have questions, suggestions, or topics you'd like us to cover? We'd love to hear from you!
          Connect with us on social media or drop us a line.
        </p>

        <p style={{ marginTop: '3rem', textAlign: 'center', fontSize: '1.5rem' }}>
          Welcome to the barbershop. Pull up a chair. ✂️
        </p>
      </div>
    </div>
  );
}

export default About;
